import React from 'react';
import '../less/pension.less';
import advantages_img_1 from '../img/advantages_img_1.png';
import advantages_img_2 from '../img/advantages_img_2.png';
import advantages_img_3 from '../img/advantages_img_3.png';
import advantages_img_4 from '../img/advantages_img_4.png';
import hero_img from '../img/hero_img.png';
import FilesForDownloadNew from "../../../../../auxiliary-components/shared/FilesForDownloadNew";
import QuestionsAdminNew from '../../../../../auxiliary-components/shared/QuestionsAdminNew';
import Hero from '../../../../../auxiliary-components/shared/HeroBlock';
import AdditionalProduct from '../../../../../auxiliary-components/shared/AdditionalProductBlock';
import Advantages from '../../../../../auxiliary-components/shared/AdvantagesBlock';
import Tariffs from '../../../../../auxiliary-components/shared/TariffsBlock';
import { pensionTariffs, newPensionClientPdf } from '../../../../../services/urls/urls';
import FAQStorybook from '@abank/abank-faq';
import Tabs from '../../../../../auxiliary-components/shared/Tabs';
import how_to_block_img_1 from '../img/how_to_block_img_1.png';
import how_to_block_img_2 from '../img/how_to_block_img_2.png';
import how_to_block_img_3 from '../img/how_to_block_img_3.png';
import HowToBlockNew from '../../../../../auxiliary-components/shared/HowToBlockNew';
import tariffsData from '../enums/tariffs_data.json';
import additionalProducts from '../enums/additional_products_data.json';
import { filterByEnvironment } from '../../../../../helpers/utils/environmentFilter';
import { Preloader } from 'MWComponents';
import { canUseDOM } from '../../../../../helpers/canUseDOM';
import new_pension_client_img from '../img/new_pension_client_img.webp';
import { getSafeLinkProps } from '../../../../../helpers/utils/urlSecurity';

export default function template() {
  const page = 'pension-page-new';

  const tabs = [{tab: 'tariffs', title: 'PENSION_NEW_TABS_TITLE_01'},
          {tab: 'calculator', title: 'PENSION_NEW_TABS_TITLE_02'}];

  const hero_data = {
    title: 'PENSION_NEW_HERO_TITLE',
    text: 'PENSION_NEW_HERO_TEXT',
    cards: [
      {
        title: 'PENSION_NEW_HERO_CARDS_TITLE_01',
        text: 'PENSION_NEW_HERO_CARDS_TEXT_01',
      },
      {
        title: 'PENSION_NEW_HERO_CARDS_TITLE_02',
        text: 'PENSION_NEW_HERO_CARDS_TEXT_02',
      },
      {
        title: 'PENSION_NEW_HERO_CARDS_TITLE_03',
        text: 'PENSION_NEW_HERO_CARDS_TEXT_03',
      }
    ]
  }

  const advantagesItems = [
    {
      img: advantages_img_1,
      title: 'PENSION_NEW_ADVANTAGES_CARDS_TITLE_01',
      text: 'PENSION_NEW_ADVANTAGES_CARDS_TEXT_01',
    },
    {
      img: advantages_img_2,
      title: 'PENSION_NEW_ADVANTAGES_CARDS_TITLE_02',
      text: 'PENSION_NEW_ADVANTAGES_CARDS_TEXT_02',
    },
    {
      img: advantages_img_3,
      title: 'PENSION_NEW_ADVANTAGES_CARDS_TITLE_03',
      text: 'PENSION_NEW_ADVANTAGES_CARDS_TEXT_03',
    },
    {
      img: advantages_img_4,
      title: 'PENSION_NEW_ADVANTAGES_CARDS_TITLE_04',
      text: 'PENSION_NEW_ADVANTAGES_CARDS_TEXT_04',
    }
  ];

  const howToBlockItems = [
    {
      img: how_to_block_img_1,
      title: 'PENSION_NEW_HOW_TO_CARDS_TITLE_01',
      text: 'PENSION_NEW_HOW_TO_CARDS_TEXT_01'
    },
    {
      img: how_to_block_img_2,
      title: 'PENSION_NEW_HOW_TO_CARDS_TITLE_02',
      text: 'PENSION_NEW_HOW_TO_CARDS_TEXT_02'
    },
    {
      img: how_to_block_img_3,
      title: 'PENSION_NEW_HOW_TO_CARDS_TITLE_03',
      text: 'PENSION_NEW_HOW_TO_CARDS_TEXT_03'
    }
  ];
  
  const questionsWidget = this.widgetsHelper.getWidget.call(this, 'questions');

  return (
    <div className="pension-page-new">
      <Hero
        data={hero_data}
        img={hero_img}
        page={page}
      />
        <div className={`content${this.state.faqTab ? ' hidden' : ''}`}>
          <section className="new-pension-client">
            <div className="container">
              <div className="new-pension-client__top">
                <div className="new-pension-client__left">
                  <div className="new-pension-client__tag">{this.l10n('PENSION_NEW_NEW_PENSION_CLIENT_TAG')}</div>
                  <h2 className="new-pension-client__title">{this.l10n('PENSION_NEW_NEW_PENSION_CLIENT_TITLE')}</h2>
                  <div className="new-pension-client__text">{this.l10n('PENSION_NEW_NEW_PENSION_CLIENT_TEXT')}</div>
                </div>
                <img className="new-pension-client__image" src={new_pension_client_img} alt={this.l10n('PENSION_NEW_NEW_PENSION_CLIENT_TAG')} loading="lazy" width="516" height="344" />
              </div>
              <div className="new-pension-client__bottom steps">
                <ul className="steps__list">
                  <li><b>{this.l10n('PENSION_NEW_NEW_PENSION_CLIENT_STEPS_LIST_01_01')}</b> {this.l10n('PENSION_NEW_NEW_PENSION_CLIENT_STEPS_LIST_01_02')}</li>
                  <li><b>{this.l10n('PENSION_NEW_NEW_PENSION_CLIENT_STEPS_LIST_02_01')}</b> {this.l10n('PENSION_NEW_NEW_PENSION_CLIENT_STEPS_LIST_02_02')}</li>
                  <li><b>{this.l10n('PENSION_NEW_NEW_PENSION_CLIENT_STEPS_LIST_03_01')}</b> {this.l10n('PENSION_NEW_NEW_PENSION_CLIENT_STEPS_LIST_03_02')}</li>
                </ul>
                <p className="steps__text">{this.l10n('PENSION_NEW_NEW_PENSION_CLIENT_STEPS_TEXT')}</p>
                <div className="steps__btns">
                  <a className="steps__btn steps__btn_black" {...getSafeLinkProps('/branches')}>{this.l10n('PENSION_NEW_NEW_PENSION_CLIENT_STEPS_BTN_01')}</a>
                  <a className="steps__btn" {...getSafeLinkProps(newPensionClientPdf)}>{this.l10n('PENSION_NEW_NEW_PENSION_CLIENT_STEPS_BTN_02')}</a>
                </div>
              </div>
            </div>
          </section>
          <Advantages
            items={advantagesItems}
            title={'PENSION_NEW_ADVANTAGES_TITLE'}
          />
          <Tabs tabs={tabs} toggle={this.toggleTab} tab={this.state.tab} page={page}>
            <Tariffs
              items={tariffsData}
              title={'PENSION_NEW_TARIFFS_TITLE'}
              btnLink={pensionTariffs}
              btnText={'PENSION_NEW_TARIFFS_BTN'}
              page={page}
            />
            <HowToBlockNew
              title={'PENSION_NEW_HOW_TO_TITLE'}
              items={howToBlockItems}
            />
          </Tabs>
          <AdditionalProduct
            items={additionalProducts}
            title={'PENSION_NEW_ADDITIONAL_PRODUCT_TITLE'}
            page={page}
          />
          {this.state.loader ? (canUseDOM ? <Preloader /> : null) : (
            <>
              <QuestionsAdminNew
                page={page}
                widget={questionsWidget}
                toggleFaqTab={this.toggleFaqTab}
                title={'PENSION_NEW_FAQ_STORYBOOK_TITLE'}
              />
              <FilesForDownloadNew
                widget={this.widgetsHelper.getWidget.call(this, 'files_to_download')}
              />
            </>
          )}
        </div>
        <div className={`content${!this.state.faqTab ? ' hidden' : ''}`}>
          <FAQStorybook
            widget={questionsWidget}
            title={this.l10n('PENSION_NEW_FAQ_STORYBOOK_TITLE')}
            btnText={this.l10n('PENSION_NEW_FAQ_STORYBOOK_BTN_TEXT')}
            onBtnClick={this.toggleFaqTab}
            filterByEnvironment={filterByEnvironment}
          />
        </div>
    </div>
  )
}
